import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn:'root' })
export class DataCacheService {
    private data: { [key: string]: any } = {};

    constructor() { }

    put(key: string, value: any, router?: Router): void {

        this.data[this.getFullKey(key, router)] = value;
    }
    get(key: string, router?: Router): any {
        return this.data[this.getFullKey(key, router)];
    }

    private getFullKey(key: string, router?: Router) {
        if (router) {
            let url = router.url;
            if (url.indexOf('?') != -1) url = url.substring(0, url.lastIndexOf('?'));
            key = key + "[router=" + url + "]";
        }
        // console.log("DataCacheService.fullKey="+key);
        return key;
    }
}
